import React, { useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { ContactUs, Home, Href, JavaScriptBehaviors, Profile, Settings } from "../../../../Constant";
import { JAVASCRIPT_DATA } from "../../../../Data/UiKit/Lists";
import { LI, UL } from "../../../../AbstractElements";
import { JavaScriptBehaviorTabContent } from "./JavaScriptBehaviorTabContent";

const JavaScriptBehavior = () => {
  const [basicTab, setBasicTab] = useState("1");
  return (
    <Col sm="12" xl="12">
      <Card>
        <CommonCardHeader title={JavaScriptBehaviors} span={JAVASCRIPT_DATA} />
        <CardBody>
          <Row>
            <Col sm="4">
              <UL>
                <LI tag="a" href={Href} className={`list-group-item-action bg-primary ${basicTab === "1" ? "active" : ""}`} onClick={() => setBasicTab("1")}>{Home}</LI>
                <LI tag="a" href={Href} className={`list-group-item-action list-hover-primary ${basicTab === "2" ? "active" : ""}`} onClick={() => setBasicTab("2")}>{Profile}</LI>
                <LI tag="a" href={Href} className={`list-group-item-action list-hover-primary ${basicTab === "3" ? "active" : ""}`} onClick={() => setBasicTab("3")}>{ContactUs}</LI>
                <LI tag="a" href={Href} className={`list-group-item-action list-hover-primary ${basicTab === "4" ? "active" : ""}`} onClick={() => setBasicTab("4")}>{Settings}</LI>
              </UL>
            </Col>
            <JavaScriptBehaviorTabContent basicTab={basicTab} />
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default JavaScriptBehavior;
